export default class BaseApi {
  baseUrl = "";

  constructor(url) {
    this.baseUrl = "/api/" + url;
  }

  _sanitize(id) {
    if (id && (id.includes?.("://") || id.startsWith?.("//"))) {
      throw new Error("Invalid ID format");
    }
    return id;
  }

  index(params = null, config = {}) {
    return axios.get(this.baseUrl, { ...config, params });
  }

  show(id, params = null, config = {}) {
    const sanitizedId = this._sanitize(id);
    return axios.get(`${this.baseUrl}/${sanitizedId}`, { ...config, params });
  }

  create(data, config = {}) {
    return axios.post(this.baseUrl, data, config);
  }

  createWithFiles(formData, config = {}) {
    return axios.post(`${this.baseUrl}`, formData, {
      ...config, headers: { ...config.headers, "Content-Type": "multipart/form-data" },
    });
  }

  update(id, data, config = {}) {
    const sanitizedId = this._sanitize(id);
    return axios.put(`${this.baseUrl}/${sanitizedId}`, data, config);
  }

  updateWithFiles(id, formData, config = {}) {
    const sanitizedId = this._sanitize(id);
    const method = formData.get("_method") || "PUT";
    return axios.post(
      `${this.baseUrl}/${sanitizedId}?_method=${method}`,
      formData,
      {
        ...config, headers: { ...config.headers, "Content-Type": "multipart/form-data" },
      },
    );
  }

  destroy(id, params = null, config = {}) {
    const sanitizedId = this._sanitize(id);
    return axios.delete(`${this.baseUrl}/${sanitizedId}`, { ...config, params });
  }
}
